/* hgn-kit-build-toggle.js — moved verbatim from snippets/hgn-kit-build-toggle.liquid on 2026-09-14 (page-weight phase B:
   inline JS → theme asset, loaded synchronously at the same position so execution order and
   DOMContentLoaded timing are unchanged). 1 original <script> block(s), in order.
   EDIT THIS FILE, not the snippet. */

(function () {
  if (window.HGN && window.HGN.mountKitBuildToggle) return;
  window.HGN = window.HGN || {};

  var TIER_LABEL = {
    classic:     'Classic Wraps Starter Kit',
    gels:        'Gel Wraps Starter Kit',
    'press-ons': 'Press-On Starter Kit'
  };
  var TIER_NOUN = {
    classic:     'classic wraps',
    gels:        'gel wraps',
    'press-ons': 'press-on designs'
  };
  var TIER_BY_HANDLE = {
    'non-uv-nail-wraps': 'classic',
    'classic-wraps':     'classic',
    'classic-nails':     'classic',
    'semi-cured-gels':   'gels',
    'gel-wraps':         'gels',
    'press-on':          'press-ons',
    'press-ons':         'press-ons',
    'soft-gel-press-ons':'press-ons'
  };

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function copyOr(copy, key, fallback) {
    var v = copy[key];
    return (v == null || v === '') ? fallback : v;
  }
  function resolveShippingTokens(s) {
    if (!s || s.indexOf('{shipping}') === -1) return s;
    var amount = '';
    try {
      var cfg = window.HGN_SIDE_CART_CONFIG && window.HGN_SIDE_CART_CONFIG.shipping;
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP';
      var key = String(cur).toLowerCase();
      var gbp = cfg && (cfg[key] || cfg.gbp);
      if (typeof gbp === 'number' && window.HGN && typeof window.HGN.formatLiveCeil === 'function') {
        amount = window.HGN.formatLiveCeil(gbp, key);
      } else if (typeof gbp === 'number') {
        amount = '\u00a3' + gbp;
      }
    } catch (e) {}
    return s.replace(/\{shipping\}/g, amount || '');
  }

  /* ───── Canonical savings claim (audit 2026-08-12) ─────
     This file carried FOUR hardcoded kit-savings numbers ("UP TO 37%
     OFF" x3, "typically a 25-37% saving") while the kit bar said 40%,
     the announcement bar 28% and the drawer computed 38%. All of them
     now resolve through hgn-kit-progress's HGN.kitSavingsRangePct(),
     which derives the figure from the REAL per-market kit math across
     this market's enabled tiers. HGN_KIT_SAVINGS_CEILING_PCT (the
     announcement-bar kit SSoT) is the pre-math fallback.

     Copy fields keep the `{savingsPct}` / `{savingsPctLow}` tokens, so
     a merchant who types a literal number into the customizer still
     wins — fillSav is a no-op on token-free strings. Same contract as
     resolveShippingTokens above. */
  function savingsRange() {
    try {
      if (window.HGN && typeof window.HGN.kitSavingsRangePct === 'function') {
        return window.HGN.kitSavingsRangePct();
      }
    } catch (e) {}
    var cfg = parseInt(window.HGN_KIT_SAVINGS_CEILING_PCT, 10);
    var high = (isFinite(cfg) && cfg > 0) ? cfg : 37;
    return { low: high, high: high };
  }
  function fillSav(str) {
    if (str == null) return str;
    var s2 = String(str);
    if (s2.indexOf('{savingsPct') === -1) return s2;
    try {
      if (window.HGN && typeof window.HGN.fillSavingsTokens === 'function') {
        return window.HGN.fillSavingsTokens(s2);
      }
    } catch (e) {}
    var r = savingsRange();
    return s2.replace(/\{savingsPctLow\}/g, String(r.low))
             .replace(/\{savingsPct\}/g, String(r.high));
  }

  /* Kit "from" price for a tier, in the visitor's money. LOCAL sticker
     first (M4 per-market prices), GBP bundle price otherwise — lifted
     verbatim out of buildTip so the tip and the PDP value line can
     never quote different prices. Returns null when unconfigured. */
  function kitPriceStr(tier) {
    var localMap = window.HGN_KIT_BUNDLE_PRICES_LOCAL || {};
    var sticker = localMap[tier];
    if (sticker && typeof sticker.amount === 'number' && isFinite(sticker.amount) &&
        sticker.amount > 0 && sticker.currency) {
      try {
        return new Intl.NumberFormat(undefined, {
          style: 'currency', currency: String(sticker.currency).toUpperCase()
        }).format(sticker.amount);
      } catch (e) {}
    }
    var prices = window.HGN_KIT_BUNDLE_PRICES || {};
    var bundlePrice = (typeof prices[tier] === 'number') ? prices[tier] : null;
    return bundlePrice ? '\u00a3' + bundlePrice.toFixed(2) : null;
  }

  /* ───── PDP value line (audit 2026-08-12) ─────
     The PDP's "Exclusive offer — Build a Starter Kit" block pitched a
     bundle without ever saying what it contains or what it costs; the
     auditors called it the only kit surface with no price anywhere.
     One line fixes it: contents + from-price + the canonical saving.

     Contents mirror HGN_KIT_ACCESSORIES in hgn-announcement.liquid —
     designs + the auto-included accessory + the gift bag.
     Optional uplift add-ons (Magic Remover, press-on tabs/glue) are
     deliberately NOT listed: they are not in the kit price.
     The design count is read per-market from STARTER_KIT_MINIMUMS, so
     a market that raises Gels to 5 gets "5 gel wraps" for free. */
  var TIER_INCLUDES = {
    classic:     'top coat',
    gels:        'lamp',
    'press-ons': 'remover'
  };
  function kitValueLine(tier) {
    if (!tier) return '';
    var minimums = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
      { classic: 5, gels: 3, 'press-ons': 3 };
    var minimum = parseInt(minimums[tier], 10) || 0;
    var noun = TIER_NOUN[tier];
    var extra = TIER_INCLUDES[tier];
    var price = kitPriceStr(tier);
    if (!minimum || !noun || !extra || !price) return '';
    var sav = tierSavingsPct(tier);
    /* Gels say what the lamp is worth and what the kit saves in money
       (kit-leak build 3, 2026-10-11, KIT-BUILD §11q): "3 gel wraps + LED
       lamp (worth £14.99) + gift bag from £49.99 — save 31% (£22.96)".
       Figures from HGN.kitOfferFacts (the drawer's own maths); before it
       is installed, or when a figure can't be trusted in this currency,
       the line is exactly what it was. Other tiers are untouched. */
    var gel = tier === 'gels' ? gelOfferFacts() : null;
    if (gel && gel.ok && gel.lampWorth && gel.savings && gel.pct > 0) {
      return minimum + ' ' + noun + ' + LED lamp (worth ' + gel.lampWorth + ') + gift bag from ' + price +
             ' \u2014 save ' + gel.pct + '% (' + gel.savings + ')';
    }
    return minimum + ' ' + noun + ' + ' + extra + ' + gift bag from ' + price +
           ' \u2014 save ' + (sav.exact ? '' : 'up to ') + sav.pct + '%';
  }
  function gelOfferFacts() {
    try {
      if (window.HGN && typeof window.HGN.kitOfferFacts === 'function') return window.HGN.kitOfferFacts('gels');
    } catch (e) {}
    return null;
  }
  /* This tier's REAL saving, not the range ceiling. computeProjectedKitMath
     is the helper the kit-lead PDP badge and the drawer money block already
     read, so the strip cannot quote a different number from the one the
     shopper meets two taps later — kit-nudge audit 2026-09-11 P1-4: the
     classic collection was still saying "UP TO 40% OFF" against a canonical
     37%. Falls back to the range ceiling before the kit-build IIFE has
     installed the math. */
  function tierSavingsPct(tier) {
    try {
      if (tier && window.HGN && typeof window.HGN.computeProjectedKitMath === 'function') {
        var m = window.HGN.computeProjectedKitMath(tier, null);
        var pct = m && parseInt(m.savingsPct, 10);
        if (isFinite(pct) && pct > 0) return { pct: pct, exact: true };
      }
    } catch (e) {}
    return { pct: savingsRange().high, exact: false };
  }
  /* Which surfaces get the value line. Was PDP-only ("collection and hero
     strips already sit next to live product prices") — the 2026-09-11
     kit-nudge audit measured that surface at ~81,500 sessions/30d with no
     price anywhere on it, the largest priceless kit pitch on the site
     (P1-4). Every strip now carries it; a surface with no resolvable tier
     still renders nothing, because kitValueLine('') is ''. */
  function wantsValueLine(target) {
    try { if (target && target.closest('.hgn-coll-kit-group--pdp')) return true; } catch (e) {}
    return !!target;
  }
  /* Tier for the value line when the caller did not name one: the page's
     own tier first, then the cheapest ENABLED tier, so /search and
     all-products quote the entry price rather than the dearest kit. */
  function valueLineTier(explicit) {
    if (explicit) return explicit;
    var detected = null;
    try { detected = detectTier(); } catch (e) {}
    if (detected) return detected;
    var prices = window.HGN_KIT_BUNDLE_PRICES || {};
    var enabled = window.HGN_KIT_ENABLED || {};
    var best = null, bestPrice = Infinity;
    ['classic', 'gels', 'press-ons'].forEach(function (t) {
      if (enabled[t] === false) return;
      try {
        var kp = window.HGN && window.HGN.kitProgress;
        if (kp && typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(t)) return;
      } catch (e) {}
      var p = prices[t];
      if (typeof p === 'number' && p > 0 && p < bestPrice) { bestPrice = p; best = t; }
    });
    return best;
  }
  function paintValueLine(group, tier) {
    if (!group) return;
    var el = group.querySelector('[data-hgn-coll-kit-toggle-value]');
    if (!el) return;
    var txt = kitValueLine(tier || group.getAttribute('data-hgn-value-tier'));
    if (!txt) { el.hidden = true; return; }
    el.hidden = false;
    if (el.textContent !== txt) el.textContent = txt;
  }
  function paintAllValueLines() {
    try {
      var groups = document.querySelectorAll('[data-hgn-value-tier]');
      Array.prototype.forEach.call(groups, function (g) { paintValueLine(g, null); });
    } catch (e) {}
  }

  /* Detect a tier from the path on collection pages. Falls back to the
     header's `HGN_CANONICAL_COLLECTIONS` global when the merchant has
     pointed canonical URLs at non-default handles. Returns null on any
     non-collection page (wishlist / recently-viewed / search) — the tip
     copies fall back to a generic "Starter Kit" line. */
  function detectTier() {
    var path = (window.location.pathname || '').toLowerCase();
    var m = path.match(/\/collections\/([^/?#]+)/);
    if (!m) return null;
    var map = {};
    Object.keys(TIER_BY_HANDLE).forEach(function (h) { map[h] = TIER_BY_HANDLE[h]; });
    var canon = window.HGN_CANONICAL_COLLECTIONS || {};
    Object.keys(canon).forEach(function (tier) {
      var url = canon[tier];
      if (!url) return;
      var match = String(url).toLowerCase().match(/\/collections\/([^/?#]+)/);
      if (match && match[1]) map[match[1]] = tier;
    });
    return map[m[1]] || null;
  }

  function tipShouldAutoOpen() {
    try {
      var qs = new URLSearchParams(window.location.search || '');
      if (qs.get('hgn_kit_intro') === '1') return true;
      if ((qs.get('utm_content') || '').toLowerCase() === 'hgn_kit_intro') return true;
      if ((qs.get('utm_campaign') || '').toLowerCase() === 'hgn_kit_intro') return true;
    } catch (e) {}
    return false;
  }

  /* "typically a 25-37% saving" was two invented numbers. Now the real
     spread across this market's enabled tiers, collapsed to a single
     figure when every tier saves the same. */
  function tipSavingsSpan() {
    var r = savingsRange();
    return (r.low && r.low < r.high)
      ? (r.low + '\u2013' + r.high + '%')
      : (r.high + '%');
  }

  function buildTip(tier) {
    var prices = window.HGN_KIT_BUNDLE_PRICES || {};
    var minimums = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
      { classic: 5, gels: 3, 'press-ons': 3 };
    var bundlePrice = (typeof prices[tier] === 'number') ? prices[tier] : null;
    var hasTier = !!tier && minimums[tier] != null;
    var minimum = hasTier ? minimums[tier] : 0;
    var noun  = TIER_NOUN[tier]  || 'designs';
    var label = TIER_LABEL[tier] || 'Starter Kit';
    /* Kit price string — LOCAL sticker first (M4): markets with
       per-market prices broadcast a fixed local-currency value via
       HGN_KIT_BUNDLE_PRICES_LOCAL, rendered with its own symbol.
       Otherwise the GBP bundle price with the pound prefix, unchanged. */
    var priceStr = null;
    var localMap = window.HGN_KIT_BUNDLE_PRICES_LOCAL || {};
    var sticker = localMap[tier];
    if (sticker && typeof sticker.amount === 'number' && isFinite(sticker.amount) &&
        sticker.amount > 0 && sticker.currency) {
      try {
        priceStr = new Intl.NumberFormat(undefined, {
          style: 'currency', currency: String(sticker.currency).toUpperCase()
        }).format(sticker.amount);
      } catch (e) { priceStr = null; }
    }
    if (!priceStr && bundlePrice) priceStr = '\u00a3' + bundlePrice.toFixed(2);
    var priceCopy = priceStr
      ? 'Pay <strong>' + priceStr + '</strong> for the whole kit \u2014 typically a ' + tipSavingsSpan() + ' saving vs. buying each item separately.' +
        (shopModeIsDropCapable() ? '<br><a href="/pages/nail-drop" style="color:inherit;opacity:.75;text-decoration:underline;text-underline-offset:3px;">Or make it a rhythm \u2014 Nail Drop delivers your picks every 4\u20138 weeks \u2192</a>' : '')
      : 'A bundle price applies once your kit is full.';
    /* Tier-undecided fallback (e.g. /pages/wishlist, /search) — describe
       the picking step generically rather than rendering "Pick 0 to fill
       your kit." Once the shopper navigates onto a tier collection the
       tip is rebuilt with the numeric step. */
    var pickStepHtml = hasTier
      ? 'Tap <strong>+ Add to Kit</strong> on any ' + escapeHtml(noun) + '. Pick <strong>' + minimum + '</strong> to fill your kit.'
      : 'Tap <strong>+ Add to Kit</strong> on any eligible design. Pick the minimum count for your chosen tier to fill your kit.';
    var stepsHtml =
      '<li class="hgn-coll-kit-tip__step">' +
        '<span class="hgn-coll-kit-tip__step-num">1.</span>' +
        '<span>Tap <strong>Build a Starter Kit</strong> above to turn on pick mode.</span>' +
      '</li>' +
      '<li class="hgn-coll-kit-tip__step">' +
        '<span class="hgn-coll-kit-tip__step-num">2.</span>' +
        '<span>' + pickStepHtml + '</span>' +
      '</li>' +
      '<li class="hgn-coll-kit-tip__step">' +
        '<span class="hgn-coll-kit-tip__step-num">3.</span>' +
        '<span>Open the bar at the top, choose your accessories, and send the whole kit to cart.</span>' +
      '</li>';
    var div = document.createElement('div');
    div.className = 'hgn-coll-kit-tip';
    div.id = 'hgn-coll-kit-tip';
    div.setAttribute('data-hgn-coll-kit-tip', '');
    /* NAILDROP: mode stamp so refreshTipForMode can tell the kit tip
       from the Nail Drop variant (buildDropTip stamps 'drop'). */
    div.setAttribute('data-hgn-tip-mode', 'kit');
    div.hidden = true;
    div.innerHTML =
      '<button type="button" class="hgn-coll-kit-tip__close" data-hgn-coll-kit-tip-close aria-label="Close">\u00d7</button>' +
      '<p class="hgn-coll-kit-tip__eyebrow">How it works</p>' +
      '<h3 class="hgn-coll-kit-tip__title">Build your ' + escapeHtml(label) + '</h3>' +
      '<ol class="hgn-coll-kit-tip__steps">' + stepsHtml + '</ol>' +
      '<p class="hgn-coll-kit-tip__price">' + priceCopy + '</p>';
    var close = div.querySelector('[data-hgn-coll-kit-tip-close]');
    if (close) close.addEventListener('click', function () { setTipOpen(false); });
    return div;
  }

  function setTipOpen(open) {
    var tip = document.querySelector('[data-hgn-coll-kit-tip]');
    var help = document.querySelector('[data-hgn-coll-kit-help]');
    if (!tip) return;
    tip.hidden = !open;
    if (help) help.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      positionTip();
      window.addEventListener('resize', positionTip);
      window.addEventListener('scroll', positionTip, true);
      setTimeout(function () {
        document.addEventListener('click', onOutsideClick, true);
        document.addEventListener('keydown', onTipKey);
      }, 0);
    } else {
      window.removeEventListener('resize', positionTip);
      window.removeEventListener('scroll', positionTip, true);
      document.removeEventListener('click', onOutsideClick, true);
      document.removeEventListener('keydown', onTipKey);
    }
  }
  function onOutsideClick(e) {
    var tip = document.querySelector('[data-hgn-coll-kit-tip]');
    var group = document.querySelector('[data-hgn-coll-kit-group]');
    if (tip && tip.contains(e.target)) return;
    if (group && group.contains(e.target)) return;
    setTipOpen(false);
  }
  function onTipKey(e) {
    if (e.key === 'Escape') setTipOpen(false);
  }
  function positionTip() {
    var tip = document.querySelector('[data-hgn-coll-kit-tip]');
    var anchor = document.querySelector('[data-hgn-coll-kit-help]') ||
                 document.querySelector('[data-hgn-coll-kit-toggle]');
    if (!tip || !anchor || tip.hidden) return;
    var GUTTER = 12;
    var GAP = 10;
    var r = anchor.getBoundingClientRect();
    var sx = window.scrollX || window.pageXOffset || 0;
    var sy = window.scrollY || window.pageYOffset || 0;
    var vw = document.documentElement.clientWidth || window.innerWidth;
    var tipW = tip.offsetWidth;
    var preferredLeft = r.right - tipW;
    var minLeft = GUTTER;
    var maxLeft = vw - tipW - GUTTER;
    var leftViewport = Math.max(minLeft, Math.min(maxLeft, preferredLeft));
    var topViewport = r.bottom + GAP;
    tip.style.left = (leftViewport + sx) + 'px';
    tip.style.top  = (topViewport + sy) + 'px';
    var anchorCenter = r.left + (r.width / 2);
    var caretX = Math.max(10, Math.min(tipW - 18, anchorCenter - leftViewport - 7));
    tip.style.setProperty('--hgn-tip-caret-x', caretX + 'px');
  }
  function placeTipOnce() {
    if (document.querySelector('[data-hgn-coll-kit-tip]')) return;
    /* NAILDROP:start */
    /* Mode-aware build (R1): Nail Drop mode gets its own tip variant;
       everything else keeps the kit tip exactly as before. Original
       line: `var tip = buildTip(detectTier());` */
    var tip = (typeof shopModeIsDrop === 'function' && shopModeIsDrop())
      ? buildDropTip(currentDropLane() || detectTier())
      : buildTip(detectTier());
    /* NAILDROP:end */
    document.body.appendChild(tip);
    if (tipShouldAutoOpen()) {
      setTipOpen(true);
      var help = document.querySelector('[data-hgn-coll-kit-help]');
      if (help) {
        help.classList.add('is-pulsing');
        setTimeout(function () { help.classList.remove('is-pulsing'); }, 3500);
      }
    }
  }


  /* Tier list — used by `renderBrowse` to iterate canonical
     collections. Order matters: dictates the left-to-right button
     order in the unfocused (three-button) state. */
  var KIT_TIERS = ['classic', 'gels', 'press-ons'];

  /* Registry of mounted browse panels — one per `mount()` call so
     `renderAllBrowses()` can re-paint every panel on kit / focus /
     build-mode events without each mount having to wire its own
     listeners. */
  var mountedBrowses = [];

  /* NAILDROP:start */
  /* ───── 3-segment Shop / Kit / Drop control ─────
     When Nail Drop is available on this page
     (HGN.shopMode.isDropAvailable(): market-enabled AND live-or-
     tester), mount() renders a segmented mode control in the slot the
     binary switch normally occupies. When Drop is UNAVAILABLE the
     binary control renders byte-identically to today — zero visual or
     behaviour change, which is the flag-off safety contract.

     Segments drive window.HGN.shopMode.set(); paint state comes back
     via `hgn:shop-mode:change` / `hgn:kit-build-mode:change` /
     `hgn:kit-off:cancelled` (the last two cover kit flips from the
     kit-bar and modal bounce-backs), so every mounted control stays
     in step — the three-state extension of the binary cross-input
     sync below. Styles live in assets/hgn-drop.css. */
  var mountedSegs = [];
  var SHOP_MODES = ['shop', 'kit', 'drop'];
  function dropSegAvailable() {
    return !!(window.HGN && window.HGN.shopMode &&
      typeof window.HGN.shopMode.isDropAvailable === 'function' &&
      window.HGN.shopMode.isDropAvailable());
  }
  function segBtnHtml(mode, label) {
    return '<button type="button" class="hgn-coll-kit-seg__btn" data-hgn-seg-mode="' +
      escapeHtml(mode) + '" aria-pressed="false"><span>' + escapeHtml(label) + '</span></button>';
  }
  function paintSeg(seg) {
    if (!seg) return;
    var sm = window.HGN && window.HGN.shopMode;
    var current = (sm && typeof sm.get === 'function') ? sm.get() : 'shop';
    SHOP_MODES.forEach(function (mode) {
      var btn = seg.querySelector('[data-hgn-seg-mode="' + mode + '"]');
      if (!btn) return;
      var active = mode === current;
      if (btn.classList.contains('is-active') !== active) {
        btn.classList.toggle('is-active', active);
      }
      var pressed = active ? 'true' : 'false';
      if (btn.getAttribute('aria-pressed') !== pressed) {
        btn.setAttribute('aria-pressed', pressed);
      }
    });
  }
  function paintAllSegs() {
    mountedSegs.forEach(paintSeg);
  }

  /* ───── Mode-aware exposition (revision R1) ─────
     The strip copy (__eyebrow/__title/__sub/__benefits), the
     "How it works" tooltip and the browse panel repaint per ACTIVE
     MODE. Kit mode / off = the existing kit strings byte-for-byte
     (recomputed from HGN_COLL_KIT_COPY exactly as mount() does);
     Nail Drop = the HGN_DROP_COPY set below. Everything is
     compare-then-write so repaint storms are no-ops. */
  function shopModeIsDropCapable() {
    var sm = window.HGN && window.HGN.shopMode;
    return !!(sm && typeof sm.isDropAvailable === 'function' && sm.isDropAvailable());
  }
  /* True only when the shopper has ACTIVELY chosen Just Shop (stored
     mode = 'shop'); an absent key is the never-touched default and
     keeps the kit ad. Storage key mirrors hgn-shop-mode.liquid. */
  function explicitShopMode() {
    try {
      var cid = 'anon';
      if (window.Shopify && window.Shopify.customer && window.Shopify.customer.id) {
        cid = String(window.Shopify.customer.id);
      } else {
        var node = document.querySelector('[data-customer-id]');
        if (node && node.getAttribute('data-customer-id') && node.getAttribute('data-customer-id') !== 'anon') {
          cid = node.getAttribute('data-customer-id');
        }
      }
      return localStorage.getItem('hgn-shop-mode:' + cid) === 'shop';
    } catch (e) { return false; }
  }
  function shopModeIsDrop() {
    var sm = window.HGN && window.HGN.shopMode;
    return !!(sm && typeof sm.get === 'function' && sm.get() === 'drop');
  }
  function dropCopyOr(key, fallback) {
    return copyOr(window.HGN_DROP_COPY || {}, key, fallback);
  }
  function currentDropLane() {
    var dq = window.HGN && window.HGN.dropQueue;
    return (dq && typeof dq.getFocus === 'function') ? dq.getFocus() : null;
  }
  var DROP_LANE_SHORT = { classic: 'Classic', gels: 'Gel', 'press-ons': 'Press-On' };

  function paintToggleCopy(group) {
    if (!group) return;
    var isDrop = shopModeIsDrop();
    var strings;
    if (isDrop) {
      strings = {
        eyebrow: dropCopyOr('stripEyebrow', 'Members save more'),
        title:   dropCopyOr('stripTitle', 'Join Nail Drop'),
        sub:     dropCopyOr('stripSub', 'Your favourite styles, delivered on your schedule — around 25% off every box, plus free gifts across your first three boxes.'),
        benefits: [
          dropCopyOr('stripBenefit1', '~25% OFF EVERY BOX'),
          dropCopyOr('stripBenefit2', 'FREE GIFTS IN YOUR FIRST 3 BOXES'),
          dropCopyOr('stripBenefit3', 'FREE SHIPPING · SKIP OR CANCEL ANYTIME')
        ]
      };
    } else if (false) { /* explicit-shop-mode exposition RETIRED (Matt,
         2026-08-13): it obscured the way back to kits. Everyone gets
         the standard kit pitch below, toggle in whatever state it's
         in — pre-2026-07-23 behaviour. Branch kept (unreachable) for
         the Nail Drop three-way chooser revisit. */
      var sc = window.HGN_SHOP_COPY || {};
      var dropOn = false;
      try {
        var smSh = window.HGN && window.HGN.shopMode;
        dropOn = !!(smSh && typeof smSh.isDropAvailable === 'function' && smSh.isDropAvailable());
      } catch (e) {}
      /* Matt 2026-08-13: shop-mode state simplified — the "Just
         shopping" exposition obscured the way BACK to kits. While in
         explicit shop mode the banner's one job is naming what the
         toggle does. Revisit as a three-way chooser when Nail Drop
         ships (Just Shop becomes a real option then). */
      strings = {
        eyebrow: copyOr(sc, 'eyebrow', 'Starter kits'),
        title:   copyOr(sc, 'title', 'Toggle on to build a Starter Kit'),
        sub:     copyOr(sc, 'sub', ((window.HGN_COPY || {}).kit_toggle_sub || 'Flip the switch and the Add buttons fill your kit instead of your bag.')),
        benefits: [
          fillSav(copyOr(sc, 'benefit1', 'UP TO {savingsPct}% OFF')),
          copyOr(sc, 'benefit2', 'GIFT BAG WITH EVERY KIT'),
          dropOn ? copyOr(sc, 'benefit3', 'OR JOIN NAIL DROP — ~25% OFF, ON YOUR RHYTHM')
                 : resolveShippingTokens(copyOr(sc, 'benefit3_nodrop', 'FREE SHIPPING OVER £39.99'))
        ]
      };
    } else {
      /* Kit strings — same sources + defaults as mount()'s initial
         paint, so restoring from drop mode is byte-identical. */
      var c = window.HGN_COLL_KIT_COPY || {};
      strings = {
        eyebrow: copyOr(c, 'eyebrow', 'Exclusive offer'),
        title:   copyOr(c, 'title', 'Build a Starter Kit'),
        sub:     copyOr(c, 'sub', 'Pick the designs you want — we bundle them at the kit price plus a gift bag on every order.'),
        benefits: [
          fillSav(copyOr(c, 'benefit1', 'UP TO {savingsPct}% OFF')),
          copyOr(c, 'benefit2', 'GIFT BAG ON EVERY KIT'),
          resolveShippingTokens(copyOr(c, 'benefit3', 'FREE SHIPPING ON ALL STARTER KITS'))
        ]
      };
    }
    var eyebrowEl = group.querySelector('.hgn-coll-kit-toggle__eyebrow');
    var titleEl   = group.querySelector('[data-hgn-coll-kit-toggle-title]');
    var subEl     = group.querySelector('[data-hgn-coll-kit-toggle-sub]');
    if (eyebrowEl && eyebrowEl.textContent !== strings.eyebrow) eyebrowEl.textContent = strings.eyebrow;
    if (titleEl && titleEl.textContent !== strings.title) titleEl.textContent = strings.title;
    if (subEl && subEl.textContent !== strings.sub) subEl.textContent = strings.sub;
    /* Value line is mode-independent (it describes the kit, not the
       active mode) — just keep its numbers current. */
    paintValueLine(group, null);
    var benefitEls = group.querySelectorAll('.hgn-coll-kit-toggle__benefit');
    for (var i = 0; i < benefitEls.length && i < strings.benefits.length; i++) {
      if (benefitEls[i].textContent !== strings.benefits[i]) {
        benefitEls[i].textContent = strings.benefits[i];
      }
    }
    if (group.classList.contains('hgn-coll-kit-group--drop') !== isDrop) {
      group.classList.toggle('hgn-coll-kit-group--drop', isDrop);
    }
  }
  function paintAllToggleCopy() {
    document.querySelectorAll('[data-hgn-coll-kit-group]').forEach(paintToggleCopy);
  }

  /* Nail Drop "How it works" tooltip — same .hgn-coll-kit-tip shell
     (shared CSS), Nail Drop content. Tier = the shopper's lane (or
     the collection's tier pre-lane); per-box price via the shared
     formatter (HGN_DROP_PRICES → live currency, never hardcoded £). */
  function buildDropTip(tier) {
    var laneShort = DROP_LANE_SHORT[tier] || '';
    var titleTpl = dropCopyOr('howtoTitle', 'Your {tier} Nail Drop');
    var title = titleTpl.split('{tier}').join(laneShort).replace(/\s{2,}/g, ' ').trim();
    var steps = [
      dropCopyOr('howtoStep1', 'Pick your Nail Drop — Classic, Gel or Press-Ons.'),
      dropCopyOr('howtoStep2', 'Tap Add to Nail Drop on designs you love. They queue in the order you want them.'),
      dropCopyOr('howtoStep3', 'Your box arrives every 4, 6 or 8 weeks — reorder your queue, skip, or get it early any time.')
    ];
    var priceStr = (window.HGN && typeof window.HGN.formatDropPrice === 'function')
      ? window.HGN.formatDropPrice(tier)
      : '';
    var priceCopy;
    if (priceStr) {
      priceCopy = escapeHtml(dropCopyOr('howtoPrice',
        'Pay {price} per box — around 25% less than buying the same items separately, with free shipping every time.'))
        .split('{price}').join('<strong>' + escapeHtml(priceStr) + '</strong>');
    } else {
      priceCopy = escapeHtml(dropCopyOr('howtoPriceNoLane',
        'Pick your Nail Drop lane to see per-box pricing — around 25% less than buying the same items separately.'));
    }
    var stepsHtml = steps.map(function (step, i) {
      return '<li class="hgn-coll-kit-tip__step">' +
        '<span class="hgn-coll-kit-tip__step-num">' + (i + 1) + '.</span>' +
        '<span>' + escapeHtml(step) + '</span>' +
      '</li>';
    }).join('');
    var div = document.createElement('div');
    div.className = 'hgn-coll-kit-tip';
    div.id = 'hgn-coll-kit-tip';
    div.setAttribute('data-hgn-coll-kit-tip', '');
    div.setAttribute('data-hgn-tip-mode', 'drop');
    div.hidden = true;
    div.innerHTML =
      '<button type="button" class="hgn-coll-kit-tip__close" data-hgn-coll-kit-tip-close aria-label="Close">×</button>' +
      '<p class="hgn-coll-kit-tip__eyebrow">How it works</p>' +
      '<h3 class="hgn-coll-kit-tip__title">' + escapeHtml(title) + '</h3>' +
      '<ol class="hgn-coll-kit-tip__steps">' + stepsHtml + '</ol>' +
      '<p class="hgn-coll-kit-tip__price">' + priceCopy + '</p>';
    var close = div.querySelector('[data-hgn-coll-kit-tip-close]');
    if (close) close.addEventListener('click', function () { setTipOpen(false); });
    return div;
  }

  /* Rebuild the cached tooltip when the mode (or the drop lane, which
     changes its title + price) no longer matches what's in the DOM.
     Re-opens in place if the shopper had it open mid-switch. */
  function refreshTipForMode() {
    var tip = document.querySelector('[data-hgn-coll-kit-tip]');
    if (!tip) return;
    var isDrop = shopModeIsDrop();
    var wantMode = isDrop ? 'drop' : 'kit';
    var haveMode = tip.getAttribute('data-hgn-tip-mode') || 'kit';
    var wantLane = isDrop ? (currentDropLane() || '') : '';
    var haveLane = tip.getAttribute('data-hgn-tip-lane') || '';
    if (haveMode === wantMode && haveLane === wantLane) return;
    var wasOpen = !tip.hidden;
    if (wasOpen) setTipOpen(false);
    if (tip.parentNode) tip.parentNode.removeChild(tip);
    var fresh = isDrop
      ? buildDropTip(currentDropLane() || detectTier())
      : buildTip(detectTier());
    fresh.setAttribute('data-hgn-tip-lane', wantLane);
    document.body.appendChild(fresh);
    if (wasOpen) setTipOpen(true);
  }

  /* Nail Drop browse panel state — the drop-mode arm of renderBrowse.
     Lane set → "Keep adding to your {lane} Nail Drop" + a Browse
     button to the lane's canonical collection (dropped when already
     there). Subscribers get the R2 inline lane note instead of a
     pitch ("Your Nail Drop is {tier} — pick anything from {label}"). */
  function renderDropBrowse(browse) {
    var lane = currentDropLane();
    if (!lane) {
      browse.hidden = true;
      browse.innerHTML = '';
      return;
    }
    var dq = window.HGN && window.HGN.dropQueue;
    var sub = (dq && typeof dq.getSubscriber === 'function') ? dq.getSubscriber() : null;
    var canon = window.HGN_CANONICAL_COLLECTIONS || {};
    var laneShort = DROP_LANE_SHORT[lane] || lane;
    var title;
    if (sub) {
      title = dropCopyOr('laneNoteSubscriber', 'Your Nail Drop is {tier} — pick anything from {label}')
        .split('{tier}').join(laneShort)
        .split('{label}').join(tierShortLabel(lane));
    } else {
      title = dropCopyOr('browseTitle', 'Keep adding to your {tier} Nail Drop')
        .split('{tier}').join(laneShort);
    }
    var onCanonical = pathMatchesCanonical(canon[lane]);
    browse.hidden = false;
    browse.classList.remove('hgn-coll-kit-browse--multi');
    var html = '<p class="hgn-coll-kit-browse__title">' + escapeHtml(title) + '</p>';
    if (!onCanonical && canon[lane]) {
      html += '<div class="hgn-coll-kit-browse__grid">' +
        '<a class="hgn-coll-kit-browse__btn" href="' + escapeHtml(canon[lane]) + '" data-hgn-coll-kit-browse-link data-tier="' + escapeHtml(lane) + '">' +
          '<span>Browse ' + escapeHtml(tierShortLabel(lane)) + '</span>' +
          '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">' +
            '<path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
        '</a>' +
      '</div>';
    }
    if (browse.innerHTML !== html) browse.innerHTML = html;
  }
  /* NAILDROP:end */


  function tierMinimum(tier) {
    var m = (window.HGN && window.HGN.STARTER_KIT_MINIMUMS) ||
      { classic: 5, gels: 3, 'press-ons': 3 };
    return m[tier] || 0;
  }

  /* Does the current page path match the given canonical collection
     URL? Match flavours:
       - Exact: `/collections/<handle>` matches itself.
       - Sub-route: `/collections/<handle>/products/<x>` matches the
         collection too (a shopper on a PDP within the canonical
         collection is "already there" enough that re-routing would
         feel like a no-op).
     Trailing slashes + casing normalised on both sides. Returns
     false for anything that doesn't carry a `/collections/<handle>`
     segment (e.g. blank canonical, /pages/x, /search). */
  function pathMatchesCanonical(canonicalUrl) {
    if (!canonicalUrl) return false;
    var canon = String(canonicalUrl).toLowerCase().replace(/\/+$/, '');
    var m = canon.match(/\/collections\/[^/?#]+/);
    if (!m) return false;
    var seg = m[0];
    var current = (window.location.pathname || '').toLowerCase().replace(/\/+$/, '');
    if (current === seg) return true;
    if (current.indexOf(seg + '/') === 0) return true;
    return false;
  }

  /* Tier label without the "Starter Kit" tail, used for browse-button
     copy ("Browse Classic Wraps", not "Browse Classic Wraps Starter
     Kit"). Keeps the kit-context implicit while letting the button
     read as a clear collection link. */
  function tierShortLabel(tier) {
    var full = TIER_LABEL[tier] || '';
    return full.replace(/\s*Starter Kit\s*$/i, '') || tier;
  }

  /* Render the browse-button panel for one mount.
     States:
       - buildMode === 'off' \u2192 hide entirely.
       - buildMode === 'on', focus tier set \u2192 single "Browse {tier}"
         button \u2192 `HGN_CANONICAL_COLLECTIONS[focus]`. Hidden when the
         shopper is already on that canonical (no point routing them
         to where they already are).
       - buildMode === 'on', focus null \u2192 three buttons, one per
         enabled tier (per-market `kp.isTierEnabled`). Buttons whose
         canonical matches the current path are dropped.
     Re-renders on kit-build-mode + focus events via the page-level
     subscription wired below. */
  function renderBrowse(browse) {
    if (!browse) return;
    /* NAILDROP:start */
    /* Drop-mode arm (R1) — Nail Drop owns the panel while drop mode
       is active; the kit logic below is untouched for every other
       mode. `renderDropBrowse` is declared in the NAILDROP block
       above (function declarations hoist within this IIFE). */
    if (typeof shopModeIsDrop === 'function' && shopModeIsDrop()) {
      renderDropBrowse(browse);
      return;
    }
    /* NAILDROP:end */
    var kp = window.HGN && window.HGN.kitProgress;
    if (!kp) { browse.hidden = true; return; }
    var buildMode = (typeof kp.getKitBuildMode === 'function') ? kp.getKitBuildMode() : 'off';
    if (buildMode !== 'on') {
      browse.hidden = true;
      browse.innerHTML = '';
      return;
    }
    var focus = (typeof kp.getFocus === 'function') ? kp.getFocus() : null;
    var canon = window.HGN_CANONICAL_COLLECTIONS || {};

    /* Hide the panel entirely when the focused kit has hit its
       minimum \u2014 the next step is conversion via the kit-bar, not
       more picks. Undecided state (focus === null) doesn't have a
       single "kit" to evaluate, so this short-circuit only applies
       to the focused state. */
    if (focus && KIT_TIERS.indexOf(focus) !== -1) {
      var min = tierMinimum(focus);
      var focusedKit = (typeof kp.read === 'function') ? (kp.read().kits[focus] || null) : null;
      var focusedPicks = (focusedKit && focusedKit.items) ? focusedKit.items.length : 0;
      if (min > 0 && focusedPicks >= min) {
        browse.hidden = true;
        browse.innerHTML = '';
        return;
      }
    }

    var tiersToOffer = [];
    if (focus && KIT_TIERS.indexOf(focus) !== -1) {
      /* Single-button state. Honour the shopper's explicit focus
         even if the tier flag is "disabled" \u2014 they chose this. */
      if (!pathMatchesCanonical(canon[focus])) tiersToOffer.push(focus);
    } else {
      /* Three-button state. Filter out per-market-disabled tiers +
         any tier whose canonical matches the current path. */
      KIT_TIERS.forEach(function (tier) {
        if (typeof kp.isTierEnabled === 'function' && !kp.isTierEnabled(tier)) return;
        if (pathMatchesCanonical(canon[tier])) return;
        tiersToOffer.push(tier);
      });
    }

    if (tiersToOffer.length === 0) {
      browse.hidden = true;
      browse.innerHTML = '';
      return;
    }

    browse.hidden = false;
    browse.classList.toggle('hgn-coll-kit-browse--multi', tiersToOffer.length > 1);
    var titleCopy = focus
      ? ('Keep picking for your ' + tierShortLabel(focus) + ' Kit')
      : 'Browse more designs for your kit';
    var html = '<p class="hgn-coll-kit-browse__title">' + escapeHtml(titleCopy) + '</p>';
    html += '<div class="hgn-coll-kit-browse__grid">';
    tiersToOffer.forEach(function (tier) {
      var href = canon[tier] || '#';
      var btnLabel = 'Browse ' + tierShortLabel(tier);
      html += '<a class="hgn-coll-kit-browse__btn" href="' + escapeHtml(href) + '" data-hgn-coll-kit-browse-link data-tier="' + escapeHtml(tier) + '">' +
        '<span>' + escapeHtml(btnLabel) + '</span>' +
        '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true">' +
          '<path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
        '</svg>' +
      '</a>';
    });
    html += '</div>';
    browse.innerHTML = html;
  }
  function renderAllBrowses() {
    mountedBrowses.forEach(function (b) { renderBrowse(b); });
  }

  function mount(target, opts) {
    opts = opts || {};
    if (!target) return;
    /* Idempotent — already populated. */
    if (target.querySelector('[data-hgn-coll-kit-toggle]')) return;
    target.setAttribute('data-hgn-coll-kit-group', '');

    var chip = document.createElement('div');
    chip.className = 'hgn-coll-kit-toggle-wrap';
    target.appendChild(chip);

    var sw = document.createElement('label');
    sw.className = 'hgn-coll-kit-toggle';
    sw.setAttribute('data-hgn-coll-kit-toggle', '');

    var copy = (window.HGN_COLL_KIT_COPY || {});
    var sEyebrow = escapeHtml(copyOr(copy, 'eyebrow', 'Exclusive offer'));
    var sTitle   = escapeHtml(copyOr(copy, 'title', 'Build a Starter Kit'));
    var sSub     = escapeHtml(copyOr(copy, 'sub', 'Pick the designs you want — we bundle them at the kit price plus a gift bag on every order.'));
    var sB1      = escapeHtml(fillSav(copyOr(copy, 'benefit1', 'UP TO {savingsPct}% OFF')));
    var sB2      = escapeHtml(copyOr(copy, 'benefit2', 'GIFT BAG ON EVERY KIT'));
    var sB3      = escapeHtml(resolveShippingTokens(copyOr(copy, 'benefit3', 'FREE SHIPPING ON ALL STARTER KITS')));
    var sHowto   = escapeHtml(copyOr(copy, 'howto', 'How it works'));
    /* Value line — "5 classic wraps + top coat + gift bag from £39.99 —
       save 37%". On the PDP it names the product's own tier; on a
       collection strip it names the collection's tier; on /search and
       all-products it names the cheapest enabled tier. Empty string when
       no tier resolves or the tier has no configured bundle price
       (kit-nudge audit 2026-09-11 C4). */
    var valueTier = wantsValueLine(target) ? valueLineTier(opts.focusOnEnable || null) : null;
    var sValue = valueTier ? kitValueLine(valueTier) : '';
    if (valueTier) target.setAttribute('data-hgn-value-tier', valueTier);
    /* Verb affordance. The switch alone reads as chrome — the audit found
       840 sessions/30d tapping "HOW IT WORKS" (an explainer) because it
       was the only thing on the card that looked tappable. The label is
       inside the <label>, so tapping it flips the same switch; the switch
       stays the mechanism and the 7-day dismiss is untouched. */
    var sVerb = escapeHtml(copyOr(copy, 'verb', 'Start my kit'));

    /* NAILDROP:start */
    /* Control slot — segmented Shop/Kit/Drop when Drop is available,
       otherwise the original binary switch UNCHANGED. */
    var controlHtml;
    if (dropSegAvailable()) {
      var dCopy = window.HGN_DROP_COPY || {};
      controlHtml =
        '<span class="hgn-coll-kit-seg" data-hgn-shop-mode-seg role="group" aria-label="Shopping mode">' +
          segBtnHtml('shop', copyOr(dCopy, 'segShop', 'Just shop')) +
          segBtnHtml('kit',  copyOr(dCopy, 'segKit',  'Build a kit')) +
          segBtnHtml('drop', copyOr(dCopy, 'segDrop', 'Nail Drop')) +
        '</span>';
    } else {
      controlHtml =
        '<span class="hgn-coll-kit-toggle__track">' +
          '<input type="checkbox" class="hgn-coll-kit-toggle__input" data-hgn-coll-kit-toggle-input aria-label="Toggle starter kit build mode">' +
          '<span class="hgn-coll-kit-toggle__thumb" aria-hidden="true"></span>' +
        '</span>';
    }
    /* NAILDROP:end */
    sw.innerHTML =
      '<span class="hgn-coll-kit-toggle__copy">' +
        '<span class="hgn-coll-kit-toggle__eyebrow">' + sEyebrow + '</span>' +
        '<span class="hgn-coll-kit-toggle__title" data-hgn-coll-kit-toggle-title>' + sTitle + '</span>' +
        '<span class="hgn-coll-kit-toggle__sub" data-hgn-coll-kit-toggle-sub>' + sSub + '</span>' +
        (sValue
          ? '<span class="hgn-coll-kit-toggle__value" data-hgn-coll-kit-toggle-value>' + escapeHtml(sValue) + '</span>'
          : '') +
        '<span class="hgn-coll-kit-toggle__benefits">' +
          '<span class="hgn-coll-kit-toggle__benefit">' + sB1 + '</span>' +
          '<span class="hgn-coll-kit-toggle__benefit">' + sB2 + '</span>' +
          '<span class="hgn-coll-kit-toggle__benefit">' + sB3 + '</span>' +
        '</span>' +
        '<span class="hgn-coll-kit-toggle__verb" data-hgn-coll-kit-toggle-verb aria-hidden="true">' + sVerb + '</span>' +
      '</span>' +
      controlHtml; /* NAILDROP: track markup moved into controlHtml above */
    chip.appendChild(sw);

    var howto = document.createElement('button');
    howto.type = 'button';
    howto.className = 'hgn-coll-kit-howto';
    howto.setAttribute('data-hgn-coll-kit-help', '');
    howto.setAttribute('aria-expanded', 'false');
    howto.innerHTML = '<span class="hgn-coll-kit-howto__icon" aria-hidden="true">?</span>' + sHowto;
    howto.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var tip = document.querySelector('[data-hgn-coll-kit-tip]');
      if (!tip) {
        placeTipOnce();
        tip = document.querySelector('[data-hgn-coll-kit-tip]');
      }
      if (!tip) return;
      setTipOpen(tip.hidden);
    });
    chip.appendChild(howto);

    /* Pre-curated kits, wave two (2026-09-11) — ONE "Start with the
       <Edit>" line under the strip when a season or tier edit is live and
       the `kitcurated` arm is B. Appended to the GROUP, never inside `sw`:
       `sw` is a <label> wrapping the build-mode switch, so a button in
       there would flip kit build mode on tap. The snippet renders nothing
       in arm A and no-ops entirely when it is not on the theme, so this
       call is safe on a theme carrying only wave one.
       Contract: redesigned/KIT-BUILD.md §11c. */
    try {
      var ck = window.HGN && window.HGN.curatedKits;
      if (ck && typeof ck.mountCollectionSlot === 'function') {
        ck.mountCollectionSlot(target, { tier: valueTier || opts.focusOnEnable || null });
      } else {
        document.addEventListener('hgn:curated-kits:ready', function once() {
          document.removeEventListener('hgn:curated-kits:ready', once);
          try {
            window.HGN.curatedKits.mountCollectionSlot(target, { tier: valueTier || opts.focusOnEnable || null });
          } catch (e) {}
        });
      }
    } catch (e) {}

    var input = sw.querySelector('[data-hgn-coll-kit-toggle-input]');
    var source = opts.source || 'kit-toggle';

    /* NAILDROP:start */
    /* Segmented-control wiring — present only when Drop is available
       (the binary input is absent in that case, hence the `if (input)`
       guard wrapping the original wiring below). Every segment click
       routes through the shop-mode arbiter, which owns the kit
       focus-modal / off-confirm flows; a `cancelled` resolution means
       a modal was dismissed and the repaint (event-driven via
       paintAllSegs) bounces the control back by itself. */
    var seg = sw.querySelector('[data-hgn-shop-mode-seg]');
    if (seg) {
      mountedSegs.push(seg);
      paintSeg(seg);
      seg.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var btn = e.target.closest('[data-hgn-seg-mode]');
        if (!btn) return;
        var mode = btn.getAttribute('data-hgn-seg-mode');
        var sm = window.HGN && window.HGN.shopMode;
        if (!sm || typeof sm.set !== 'function') return;
        var setOpts = { source: source };
        /* PDP-style callers pass `focusOnEnable` to skip the kit
           focus modal — same contract as the binary switch. */
        if (mode === 'kit' && opts.focusOnEnable) setOpts.focus = opts.focusOnEnable;
        sm.set(mode, setOpts).then(function () { paintAllSegs(); });
      });
    }
    if (input) {
    /* NAILDROP:end — `if (input)` guard closes after the original
       change handler below (binary control absent in seg mode). */
    /* Initial sync from kit-progress (once it's loaded). */
    try {
      if (window.HGN.kitProgress && typeof window.HGN.kitProgress.getKitBuildMode === 'function') {
        input.checked = window.HGN.kitProgress.getKitBuildMode() === 'on';
      }
    } catch (e) {}

    input.addEventListener('change', function () {
      if (!window.HGN || !window.HGN.kitProgress) return;
      var kp = window.HGN.kitProgress;
      if (input.checked) {
        /* OFF→ON — setKitBuildMode opens the focus modal itself when no
           focus opt is supplied; cancellation bounces the switch back.
           Callers (e.g. PDP toggle on a tier-mapped product) can pass
           `opts.focusOnEnable` to auto-set focus and skip the modal. */
        var enableOpts = { source: source };
        if (opts.focusOnEnable) enableOpts.focus = opts.focusOnEnable;
        kp.setKitBuildMode('on', enableOpts).then(function (res) {
          if (res && res.cancelled) input.checked = false;
        });
      } else {
        /* ON→OFF — hand off to the kit-bar's own switch (canonical OFF
           confirm modal) when picks exist; flip silently otherwise. */
        var picks = (typeof kp.totalKitPicks === 'function') ? kp.totalKitPicks() : 0;
        if (picks === 0) {
          kp.setKitBuildMode('off', { source: source + '-no-picks' });
          return;
        }
        var barInput = document.querySelector('[data-hgn-kit-bar-switch-input]');
        if (barInput && barInput.checked) {
          barInput.checked = false;
          barInput.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (typeof window.HGN.openKitOffModal === 'function') {
          window.HGN.openKitOffModal({ source: source, cancelSource: source });
        }
      }
    });
    /* NAILDROP:start */
    } /* end `if (input)` — binary-control wiring skipped in seg mode */
    /* NAILDROP:end */


    /* Browse panel — sibling of the toggle-wrap. The slot canvas +
       CTL drawer now live on the kit-bar (merged 2026-05-12), so this
       panel is the only kit-build surface left in the hero variant. */
    var browse = document.createElement('div');
    browse.className = 'hgn-coll-kit-browse';
    browse.setAttribute('data-hgn-coll-kit-browse', '');
    browse.hidden = true;
    target.appendChild(browse);
    mountedBrowses.push(browse);

    /* Initial paint — also runs on every kit / focus / build-mode
       event via the page-level subscription wired below. */
    renderBrowse(browse);

    /* Dismiss × — non-PDP variants only. Appended INSIDE the chip
       (toggle-wrap), not the outer kit-group, so it sits on the
       card's actual top-right corner — anchoring to the group
       would put it in the hero variant's outer bone-panel padding
       gutter. Click stores a 7-day localStorage flag;
       `applyKitGroupVisibility` hides every mounted group while
       it's active. A kit-deep-link UTM clears the flag (handled at
       script init). The PDP variant is exempt because its
       visibility is tier-eligibility-gated, not user-choice.
       While kit-build mode is already ON, the × is hidden via CSS
       (`body.hgn-kit-active`) — at that point the shopper has
       engaged and the kit-bar's OFF affordance is the right exit. */
    if (!target.classList.contains('hgn-coll-kit-group--pdp')) {
      var dismiss = document.createElement('button');
      dismiss.type = 'button';
      dismiss.className = 'hgn-coll-kit-dismiss';
      dismiss.setAttribute('data-hgn-coll-kit-dismiss', '');
      dismiss.setAttribute('aria-label', 'Hide this for now');
      dismiss.setAttribute('title', 'Hide this for now');
      dismiss.innerHTML = '×';
      dismiss.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        setDismissedNow();
        applyKitGroupVisibility();
      });
      chip.appendChild(dismiss);
    }

    /* Visibility gate — hide the kit-group wrapper on pages OTHER
       than the one where kit mode was first turned on, and when the
       dismiss flag is live. See `computeKitGroupHidden` for the
       rules. CRITICAL: apply directly to `target` rather than going
       through `applyKitGroupVisibility` (which uses
       `document.querySelectorAll`). When mount() runs from
       collection-chrome's `buildToggle()`, the target is still
       in-memory only — not yet inserted into the DOM — so a
       DOM-wide query would miss it and the visibility never applies.
       Also run the DOM-wide pass so any other already-mounted
       groups get re-evaluated (e.g. wishlist + recently-viewed
       both mount on those pages). */
    target.hidden = computeKitGroupHidden(target);
    applyKitGroupVisibility();

    /* NAILDROP:start */
    /* Landing with drop mode already active — swap the freshly
       mounted kit strings for the Nail Drop copy set (R1). No-op in
       shop/kit mode (compare-then-write). */
    paintToggleCopy(target);
    /* NAILDROP:end */

    placeTipOnce();
  }

  /* ───── User-dismiss memory ─────
     The shopper can hide the kit-build toggle for a ~7-day window
     via the × button on the chip. Persisted in localStorage so it
     survives across sessions — distinct from the activation-page
     memory below (sessionStorage; about "stop spamming this session
     while in build mode"). This one's about "I've seen it; don't
     show me again for a while".

     Override: landing via any kit-deep-link UTM clears the flag.
     Fresh intent trumps prior dismiss. */
  var DISMISS_KEY = 'hgn_kit_toggle_dismissed_until';
  var DISMISS_TTL_MS = 7 * 24 * 60 * 60 * 1000;
  function hasKitUtmIntent() {
    try {
      var qs = new URLSearchParams(window.location.search || '');
      if (qs.get('hgn_kit') === '1') return true;
      if (qs.get('hgn_kit_focus')) return true;
      if (qs.get('hgn_kit_intro') === '1') return true;
      var utmC = (qs.get('utm_content') || '').toLowerCase();
      var utmK = (qs.get('utm_campaign') || '').toLowerCase();
      if (utmC === 'hgn_kit_intro' || utmK === 'hgn_kit_intro') return true;
    } catch (e) {}
    return false;
  }
  function getDismissedUntil() {
    try {
      var v = localStorage.getItem(DISMISS_KEY);
      var n = v ? parseInt(v, 10) : 0;
      return isFinite(n) ? n : 0;
    } catch (e) { return 0; }
  }
  function isDismissed() {
    var until = getDismissedUntil();
    if (until <= 0) return false;
    if (Date.now() < until) return true;
    /* Expired — clean up so the key doesn't linger. */
    try { localStorage.removeItem(DISMISS_KEY); } catch (e) {}
    return false;
  }
  function setDismissedNow() {
    try { localStorage.setItem(DISMISS_KEY, String(Date.now() + DISMISS_TTL_MS)); }
    catch (e) {}
  }
  function clearDismiss() {
    try { localStorage.removeItem(DISMISS_KEY); }
    catch (e) {}
  }
  /* UTM intent override — runs once at script init. */
  if (hasKitUtmIntent()) clearDismiss();

  /* Debug surface — read/poke the dismiss state from DevTools:
       HGN.kitDismiss.check()  → { raw, until, msRemaining, isDismissed }
       HGN.kitDismiss.set()    → write flag + re-evaluate visibility
       HGN.kitDismiss.clear()  → wipe flag + re-evaluate visibility
     Exposed because the dismiss flag has historically been fiddly to
     debug (localStorage in private windows / iframes / Markets stores
     behaves differently). */
  window.HGN.kitDismiss = {
    check: function () {
      var raw;
      try { raw = localStorage.getItem(DISMISS_KEY); } catch (e) { raw = '<localStorage threw>'; }
      var until = getDismissedUntil();
      return {
        raw: raw,
        until: until,
        msRemaining: until > 0 ? until - Date.now() : 0,
        isDismissed: isDismissed()
      };
    },
    set: function () { setDismissedNow(); applyKitGroupVisibility(); return window.HGN.kitDismiss.check(); },
    clear: function () { clearDismiss(); applyKitGroupVisibility(); return window.HGN.kitDismiss.check(); },
    ttlMs: DISMISS_TTL_MS,
    key: DISMISS_KEY
  };

  /* ───── Activation-page memory (one-shot) ─────
     When kit mode flips ON, record the current pathname so we can
     keep the kit-group toggle visible on that page only — once the
     shopper is deep into browsing for picks, the toggle on every
     other surface just steals attention.

     The pass is one-shot: as soon as the shopper navigates AWAY
     from the activation page, the token is marked "consumed" and
     the group stays hidden on every page (including back on the
     original activation page). The only way to get the toggle back
     is a fresh OFF→ON cycle from the kit-bar — that re-seeds the
     activation path and clears the consumed flag.

     Scoped to sessionStorage because:
       • the activation memory is per-session by design — kit-mode
         persisted from a prior session (localStorage) should land
         the shopper in the "already-deep" state, not in a fresh
         activation,
       • kit picks themselves live in localStorage (kit-progress), so
         coming back later still surfaces the in-progress kit via the
         kit-bar + side cart.
     If kit mode is already ON when the page loads and no activation
     path is stored, we treat the shopper as "already deep" — the
     group stays hidden until they explicitly flip OFF→ON via the
     kit-bar. */
  var ACTIVATION_KEY  = 'hgn_kit_activation_path';
  var CONSUMED_KEY    = 'hgn_kit_activation_consumed';
  function normalisePath(p) {
    if (!p) return '';
    p = String(p);
    /* Strip trailing slash so /collections/foo and /collections/foo/
       compare equal. Keep query / hash off the table — same
       collection / pdp regardless of filters or scroll anchors. */
    if (p.length > 1 && p.charAt(p.length - 1) === '/') p = p.slice(0, -1);
    return p.toLowerCase();
  }
  function getActivationPath() {
    try { return sessionStorage.getItem(ACTIVATION_KEY) || ''; }
    catch (e) { return ''; }
  }
  function setActivationPath(p) {
    try { sessionStorage.setItem(ACTIVATION_KEY, p); }
    catch (e) {}
  }
  function clearActivationPath() {
    try {
      sessionStorage.removeItem(ACTIVATION_KEY);
      sessionStorage.removeItem(CONSUMED_KEY);
    }
    catch (e) {}
  }
  function isActivationConsumed() {
    try { return sessionStorage.getItem(CONSUMED_KEY) === '1'; }
    catch (e) { return false; }
  }
  function markActivationConsumed() {
    try { sessionStorage.setItem(CONSUMED_KEY, '1'); }
    catch (e) {}
  }
  function clearConsumedFlag() {
    try { sessionStorage.removeItem(CONSUMED_KEY); }
    catch (e) {}
  }

  /* Show every mounted kit-group when kit mode is OFF. When ON,
     show the group ONLY on the activation page and only until the
     shopper navigates away. The rules:

       • No stored path → hide. Kit mode is on but we never recorded
         an activation page in this session, so kit was switched on
         in a prior session and persisted via localStorage. Treat
         the shopper as "already deep" — surfacing the toggle now
         would steal attention.
       • Consumed flag is set → hide everywhere. The only reset is
         a fresh OFF→ON from the kit-bar.
       • Stored path matches current page → show.
       • Stored path differs from current page → mark consumed, hide.

     Uses `hidden` rather than a CSS class so the wrapper occupies
     no layout space on hidden pages — the kit-group is usually a
     hero strip, so leaving an empty padded slot would create a
     visible gap. */
  /* Compute the hidden state for ONE kit-group. Pulled out so mount()
     can apply it to a just-created `target` before that target is in
     the DOM (querySelectorAll wouldn't find it yet — that was a real
     bug). The activation-page side effect (`markActivationConsumed`)
     fires here too; it's idempotent (sessionStorage.setItem of an
     already-set value is a no-op). */
  function computeKitGroupHidden(group) {
    if (!group) return false;
    var kp = window.HGN && window.HGN.kitProgress;
    var on = false;
    try {
      on = !!(kp && typeof kp.getKitBuildMode === 'function' &&
              kp.getKitBuildMode() === 'on');
    } catch (e) {}
    if (!on) {
      /* Kit mode OFF — dismiss flag gates visibility for non-PDP
         variants. PDP variant is exempt (its visibility is owned by
         tier eligibility inside the ASK block, not user choice). */
      if (group.classList.contains('hgn-coll-kit-group--pdp')) return false;
      return isDismissed();
    }
    var stored = getActivationPath();
    var current = normalisePath(window.location.pathname);
    if (!stored) return true;
    if (isActivationConsumed()) return true;
    if (stored === current) return false;
    markActivationConsumed();
    return true;
  }
  function applyKitGroupVisibility() {
    var groups = document.querySelectorAll('[data-hgn-coll-kit-group]');
    for (var i = 0; i < groups.length; i++) {
      groups[i].hidden = computeKitGroupHidden(groups[i]);
    }
  }

  /* Page-level sync — keep every mounted input + browse panel in
     step with kit-build mode flips from any source (kit-bar switch,
     another tab, OFF/ON modal cancel). Wired once per page. */
  if (!window.HGN._kitToggleListenersWired) {
    window.HGN._kitToggleListenersWired = true;
    document.addEventListener('hgn:kit-build-mode:change', function (e) {
      var to = e.detail && e.detail.to;
      var inputs = document.querySelectorAll('[data-hgn-coll-kit-toggle-input]');
      for (var i = 0; i < inputs.length; i++) inputs[i].checked = (to === 'on');
      /* Capture the activation page on every OFF→ON flip; clear it
         on ON→OFF so the next activation gets a fresh page memory.
         The flip always originates on the current page (whether from
         this toggle, the kit-bar switch, or a product-card "Add to
         kit" auto-on), so window.location.pathname is the right
         anchor. Clear the consumed flag on OFF→ON so the one-shot
         restarts — without this, a re-toggle from the kit-bar
         would still find the burned token and keep the group
         hidden on its own re-activation page. */
      if (to === 'on') {
        setActivationPath(normalisePath(window.location.pathname));
        clearConsumedFlag();
      } else {
        clearActivationPath();
      }
      applyKitGroupVisibility();
      renderAllBrowses();
    });
    document.addEventListener('hgn:kit-off:cancelled', function () {
      var inputs = document.querySelectorAll('[data-hgn-coll-kit-toggle-input]');
      for (var i = 0; i < inputs.length; i++) inputs[i].checked = true;
    });
    document.addEventListener('hgn:kit:change', renderAllBrowses);
    /* The value line quotes money + a per-market saving, so it repaints
       on FX and currency changes as well as kit math arriving. */
    document.addEventListener('hgn:fx:update', paintAllValueLines);
    document.addEventListener('shopify:currency:update', paintAllValueLines);
    document.addEventListener('hgn:kit:change', paintAllValueLines);
    document.addEventListener('hgn:kit-math:ready', paintAllValueLines);
    window.addEventListener('load', paintAllValueLines);
    document.addEventListener('hgn:kit:focus:change', renderAllBrowses);
  }

  /* NAILDROP:start */
  /* Three-state cross-input sync + mode-aware exposition repaints
     (R1). `hgn:kit-build-mode:change` and `hgn:kit-off:cancelled`
     cover kit flips that bypass the arbiter (kit-bar switch, UTM
     boot, off-modal bounce-back); `hgn:shop-mode:change` covers
     shop↔drop flips and cross-tab storage syncs;
     `hgn:drop:focus:change` re-titles the tooltip + browse panel when
     the lane changes; `hgn:drop:change` surfaces the subscriber lane
     note once /api/drop/state lands. Every painter derives its state
     fresh (HGN.shopMode.get() / dropQueue.getFocus()) and is
     compare-then-write, so event ordering never matters. */
  if (!window.HGN._dropSegListenersWired) {
    window.HGN._dropSegListenersWired = true;
    function repaintDropExposition() {
      paintAllSegs();
      paintAllToggleCopy();
      refreshTipForMode();
      renderAllBrowses();
    }
    document.addEventListener('hgn:shop-mode:change', repaintDropExposition);
    document.addEventListener('hgn:kit-build-mode:change', repaintDropExposition);
    document.addEventListener('hgn:kit-off:cancelled', repaintDropExposition);
    document.addEventListener('hgn:drop:focus:change', repaintDropExposition);
    document.addEventListener('hgn:drop:change', function () {
      paintAllToggleCopy();
      renderAllBrowses();
    });
  }
  /* NAILDROP:end */

  window.HGN.mountKitBuildToggle = mount;
})();
